import React, { useState } from "react";
import { useAuth } from "./AuthContext";
import { supabase } from "./supabaseClient";


export default function Support() {

  return (
    <div className="ml-0 md:ml-0 flex-1 flex flex-col justify-start bg-[#111] text-[#eee] font-nunito">
      <div className="w-full max-w-3xl space-y-6 md:space-y-8">
        <h2 className="text-xl md:text-2xl font-semibold tracking-tight">Support</h2>

        <div className="w-full md:w-[800px] bg-[#151515] border border-[#252525] shadow-md rounded-xl p-6 space-y-4">
          <p>If you need support, want to discuss custom plans, or have feedback or ideas, please email: <a className="underline" href="mailto:playsetapp@gmail.com">playsetapp@gmail.com</a></p>
        </div>
      </div>
    </div>
  );
};
